/**
 * Componente de notificação toast com funções helper
 * 
 * Uso:
 * import { toast } from "@/components/ToastNotification";
 * 
 * toast.success("Operação realizada com sucesso!");
 * toast.error("Erro ao salvar dados");
 * toast.warning("Atenção: Verifique os dados");
 * toast.info("Informação importante");
 */

import { toast as baseToast } from "@/hooks/use-toast";

type ToastVariant = "default" | "destructive" | "success" | "warning" | "info";

interface ToastOptions {
  title?: string;
  description?: string;
  duration?: number;
}

const toast = {
  success: (message: string, options?: ToastOptions) => {
    return baseToast({
      variant: "success",
      title: options?.title || "Sucesso",
      description: message,
      duration: options?.duration || 2000,
    });
  },

  error: (message: string, options?: ToastOptions) => {
    return baseToast({
      variant: "destructive",
      title: options?.title || "Erro",
      description: message,
      duration: options?.duration || 5000,
    });
  },

  warning: (message: string, options?: ToastOptions) => {
    return baseToast({
      variant: "warning",
      title: options?.title || "Atenção",
      description: message,
      duration: options?.duration || 5000,
    });
  },

  info: (message: string, options?: ToastOptions) => {
    return baseToast({
      variant: "info",
      title: options?.title || "Informação",
      description: message,
      duration: options?.duration || 5000,
    });
  },

  default: (message: string, options?: ToastOptions) => {
    return baseToast({
      variant: "default",
      title: options?.title,
      description: message,
      duration: options?.duration || 5000,
    });
  },
};

export { toast };

